var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 524,
    height: 477,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 524 0 L 524 477 L 0 477 L 0 0 Z M 240 56 L 238 57 L 232 64 L 232 111 L 162 111 L 155 114 L 149 122 L 149 131 L 148 132 L 148 147 L 149 148 L 148 150 L 137 150 L 129 154 Q 121 159 119 170 L 119 264 L 99 270 L 82 277 L 73 289 L 73 304 L 81 324 L 81 328 L 83 330 L 83 333 L 85 335 Q 86 343 90 349 L 92 358 L 94 360 L 94 364 L 103 386 L 107 401 L 109 403 L 111 412 L 124 448 L 113 445 L 96 446 L 90 449 L 87 449 L 68 459 L 53 461 L 51 463 Q 50 467 54 468 L 69 467 L 91 456 L 102 453 L 119 454 L 146 467 Q 152 465 154 468 L 174 467 L 195 456 L 206 453 L 223 454 L 250 467 L 258 467 L 259 468 L 278 467 L 295 458 L 310 453 L 328 454 L 355 467 Q 361 465 363 468 L 382 467 L 403 456 L 415 453 L 432 454 L 459 467 Q 465 465 467 468 L 475 467 Q 477 466 476 462 L 461 459 L 441 449 L 425 445 L 409 446 L 402 449 L 410 429 L 411 423 L 413 421 L 417 406 L 426 384 L 426 380 L 428 378 L 430 369 L 434 361 L 436 352 L 439 347 L 439 344 L 443 336 L 443 332 L 447 325 L 447 321 L 455 300 L 455 293 L 451 283 L 442 275 L 417 266 L 411 265 L 409 264 L 409 173 Q 407 163 402 158 Q 398 152 391 150 L 378 150 L 378 122 L 375 117 L 367 111 L 295 111 L 295 64 L 294 62 L 288 56 L 240 56 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 290.5 59 L 291.5 61 L 290.5 59 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 162.5 112 L 232 112.5 L 162.5 113 L 162.5 112 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 295.5 112 L 365 112.5 L 295.5 113 L 295.5 112 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 141.5 156 L 374.5 156 L 375.5 157 L 380.5 156 Q 382.3 158.7 388.5 157 L 396 161 L 401 170.5 L 401 261 L 382 255.5 L 383 254.5 L 383 168.5 L 378 160 L 376 160 Q 377.1 157.3 374.5 158 L 373.5 157 L 141.5 157 L 141.5 156 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 132.5 160 L 129.5 164 L 132.5 160 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 125.5 172 L 126 260.5 L 127 261.5 L 125 262 L 125.5 172 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 407.5 174 L 408 263.5 L 407 263.5 L 407.5 174 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 156.5 175 L 245 175.5 L 156.5 176 L 156.5 175 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 282.5 175 L 370 175.5 L 282.5 176 L 282.5 175 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 119.5 176 L 120 257.5 L 119 257.5 L 119.5 176 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 249.5 177 L 251.5 180 L 249.5 177 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 277.5 177 L 275.5 180 L 277.5 177 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 374.5 177 L 375.5 179 L 374.5 177 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 149.5 180 L 148.5 182 L 149.5 180 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 157.5 182 L 243.5 182 L 247 184.5 L 248 186.5 L 248 218.5 L 235.5 224 L 154.5 252 L 154 185.5 L 157.5 182 Z M 160 189 L 161 231 Q 164 220 171 213 Q 183 197 202 190 L 160 189 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 282.5 182 L 369.5 182 L 373 185.5 L 372.5 252 L 314.5 231 L 288.5 223 L 279 218.5 L 279 186.5 L 282.5 182 Z M 288 189 L 287 192 L 287 211 L 288 212 L 287 215 L 288 218 L 295 219 L 304 207 Q 314 195 330 190 L 288 189 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 254.5 185 L 255 216.5 L 254 216.5 L 254.5 185 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 272.5 185 L 273 216.5 L 272 216.5 L 272.5 185 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 257.5 216 L 260 216.5 L 257.5 217 L 257.5 216 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 266.5 216 L 270 216.5 L 266.5 217 L 266.5 216 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 147.5 253 L 146.5 255 L 145 254.5 L 147.5 253 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 379.5 253 L 380.5 255 L 379.5 253 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 119.5 260 L 120 263.5 L 119 263.5 L 119.5 260 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 147.5 295 Q 150.5 294.1 149 298.5 L 147 307.5 L 146 327.5 L 144 336.5 L 143 354.5 L 142 355.5 L 142 363.5 L 140 373.5 L 140 383.5 L 139 384.5 L 138 402.5 L 137 403.5 L 137 411.5 L 135.5 418 L 100 311.5 L 101.5 310 L 104.5 310 L 147.5 295 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 56.5 461 L 59 461.5 L 56.5 462 L 56.5 461 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(56,76,106)",
    stroke: "rgb(56,76,106)",
    strokeWidth: 1,
    opacity: 0.9882352941176471,
    d: "M 474.5 465 L 473.5 467 L 474.5 465 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 242.5 56 L 280 56.5 L 242.5 57 L 242.5 56 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 238.5 57 L 240 57.5 L 237.5 59 L 238.5 57 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 234.5 61 L 234 62.5 L 233.5 64 L 233 62.5 L 234.5 61 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 232.5 66 L 233 111.5 L 232 111.5 L 232.5 66 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 294.5 67 L 295 111.5 L 294 111.5 L 294.5 67 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 155.5 114 L 152.5 118 L 155.5 114 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 372.5 115 L 374.5 118 L 372.5 115 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 360.5 118 L 364 118.5 L 360.5 119 L 360.5 118 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 375.5 119 L 377 121.5 L 376 121.5 L 375.5 119 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 149.5 123 L 150 149.5 L 149 149.5 L 149.5 123 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 377.5 124 L 378 149.5 L 377 149.5 L 377.5 124 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 128.5 155 L 124.5 160 L 128.5 155 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 398.5 155 L 402.5 160 L 398.5 155 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 139.5 157 L 373.5 157 L 376 158 L 376 160 Q 378.7 158.9 378 161.5 L 383 168.5 L 383 255 L 380 253.5 L 380 184.5 L 374.5 177 L 369.5 175 L 282.5 175 L 275 179.5 L 272 185.5 L 272 217 L 269.5 216 L 257.5 216 L 255 217 L 255 185.5 L 249.5 177 L 244.5 175 L 156.5 175 L 148 181.5 L 147 184.5 L 147 254 L 126 261 L 126 170.5 Q 128.1 162.6 134.5 159 L 139.5 157 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 403.5 161 L 404.5 163 L 403.5 161 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 119.5 170 L 120 172.5 L 119 172.5 L 119.5 170 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 407.5 170 L 408 173.5 L 407 173.5 L 407.5 170 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 160 189 L 202 189.5 Q 182.5 197 171 212.5 Q 164 220 160.5 231 L 160 189 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 288 189 L 330 189.5 Q 314.4 195.4 304 206.5 L 295 219 L 288 218 L 287 214.5 L 288 211.5 L 287 210.5 L 287 191.5 L 288 189 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 82.5 277 L 80.5 280 L 82.5 277 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 445.5 278 L 450.5 284 L 445.5 278 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 78.5 281 L 76.5 284 L 78.5 281 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 440.5 299 L 441.5 301 L 440.5 299 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 98.5 446 L 102 446.5 L 98.5 447 L 98.5 446 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 112.5 446 L 116 446.5 L 112.5 447 L 112.5 446 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 411.5 446 L 415 446.5 L 411.5 447 L 411.5 446 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 425.5 446 L 429 446.5 L 425.5 447 L 425.5 446 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 401.5 448 L 402.5 450 Q 399.7 450.7 401.5 448 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 100.5 452 L 104 452.5 L 100.5 453 L 100.5 452 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 111.5 452 L 115 452.5 L 111.5 453 L 111.5 452 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 204.5 452 L 208 452.5 L 204.5 453 L 204.5 452 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 215.5 452 L 219 452.5 L 215.5 453 L 215.5 452 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 308.5 452 L 312 452.5 L 308.5 453 L 308.5 452 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 319.5 452 L 323 452.5 L 319.5 453 L 319.5 452 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 412.5 452 L 416 452.5 L 412.5 453 L 412.5 452 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 424.5 452 L 428 452.5 L 424.5 453 L 424.5 452 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 398.5 457 L 400 457.5 L 397.5 459 L 398.5 457 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 443.5 458 L 444.5 460 L 443.5 458 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 186.5 459 L 185.5 461 L 184 460.5 L 186.5 459 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 62.5 460 L 65 460.5 L 62.5 461 L 62.5 460 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 463.5 460 L 466 460.5 L 463.5 461 L 463.5 460 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 53.5 461 L 56 461.5 L 52.5 463 L 53.5 461 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 286.5 461 L 288 461.5 L 284.5 463 L 284.5 462 L 286.5 461 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 470.5 461 Q 474.3 460.3 475 462.5 L 473.5 462 Q 469.5 462.7 470.5 461 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 63.5 466 L 66 466.5 L 63.5 467 L 63.5 466 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 167.5 466 L 170 466.5 L 167.5 467 L 167.5 466 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 253.5 466 L 256 466.5 L 253.5 467 L 253.5 466 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 271.5 466 L 274 466.5 L 271.5 467 L 271.5 466 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 357.5 466 L 360 466.5 L 357.5 467 L 357.5 466 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 376.5 466 L 379 466.5 L 376.5 467 L 376.5 466 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 54.5 467 L 58 467.5 L 54.5 468 L 54.5 467 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 155.5 467 L 162 467.5 L 155.5 468 L 155.5 467 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 258.5 467 L 266 467.5 L 258.5 468 L 258.5 467 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 365.5 467 L 371 467.5 L 365.5 468 L 365.5 467 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(92,112,143)",
    stroke: "rgb(92,112,143)",
    strokeWidth: 1,
    opacity: 0.9450980392156862,
    d: "M 468.5 467 L 473 467.5 L 468.5 468 L 468.5 467 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 280.5 63 L 282 64.5 L 282 111.5 L 281 111.5 L 281 64.5 L 280.5 63 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 158.5 119 L 156.5 122 L 158.5 119 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 156.5 150 L 354 150.5 L 156.5 151 L 156.5 150 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 147.5 188 L 148 190.5 L 147 190.5 L 147.5 188 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 379.5 191 L 380 248.5 L 379 248.5 L 379.5 191 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 260.5 239 L 267 239.5 L 256.5 241 L 256.5 240 L 260.5 239 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 268.5 240 L 272 240.5 L 268.5 241 L 268.5 240 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 273.5 241 L 277 242.5 L 275.5 243 L 273.5 241 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 282.5 244 L 286 245.5 L 284.5 246 L 282.5 244 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 234.5 247 L 236 247.5 L 232.5 249 L 232.5 248 L 234.5 247 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 223.5 251 L 222.5 253 L 221 252.5 L 223.5 251 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 261 260 L 266 260 L 266 261.5 L 267 262.5 L 267 407.5 L 266 410 L 261 410 L 261 408.5 L 260 407.5 L 260 262.5 L 261 260 Z M 263 261 L 261 263 L 261 408 L 265 409 L 266 408 L 266 263 L 263 261 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 331.5 261 L 336 262.5 L 333.5 263 L 331.5 261 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 171.5 269 L 170.5 271 L 169 270.5 L 171.5 269 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 165.5 271 L 164.5 273 L 163 272.5 L 165.5 271 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 360.5 271 L 365 272.5 L 362.5 273 L 360.5 271 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 157.5 274 L 160 274.5 L 157.5 275 L 157.5 274 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 368.5 274 L 373 275.5 L 371.5 276 L 368.5 275 L 368.5 274 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 154.5 275 L 156 275.5 L 151.5 277 L 151.5 276 L 154.5 275 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 377.5 277 L 383 279.5 L 381.5 279 Q 376.7 279 377.5 277 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 385.5 280 L 388 280.5 L 385.5 281 L 385.5 280 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 137.5 281 L 136.5 283 L 137.5 281 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 389.5 281 L 393 282.5 L 390.5 283 L 389.5 281 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 442.5 283 L 444.5 286 L 442.5 283 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 119.5 287 L 118.5 289 L 117 288.5 L 119.5 287 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 396.5 288 L 397 290.5 L 392.5 303 L 392 301.5 L 396.5 288 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 111.5 290 L 115 290.5 L 111.5 291 L 111.5 290 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 107.5 291 L 109 291.5 L 102.5 294 L 102.5 293 L 107.5 291 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 78.5 294 L 79 296.5 L 78 296.5 L 78.5 294 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 91.5 297 L 92 299 L 90 298.5 L 91.5 297 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 88.5 299 L 84.5 304 L 88.5 299 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 437.5 300 L 439.5 301 L 441 300.5 L 440.5 303 L 437.5 300 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 391.5 304 L 392 306.5 L 391 306.5 L 391.5 304 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 84.5 305 L 82.5 308 L 84.5 305 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 389.5 311 L 390 313.5 L 385.5 326 L 385 323.5 L 389.5 311 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 382.5 333 L 383 335.5 L 376.5 352 L 376 350.5 L 382.5 333 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 96.5 347 L 98 351.5 L 97 351.5 L 96.5 347 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 375.5 354 L 376 355.5 L 372.5 364 L 372 362.5 L 375.5 354 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 371.5 365 L 372 366.5 L 369.5 372 L 369 370.5 L 371.5 365 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 367.5 376 L 368 377.5 L 360.5 395 L 360 393.5 L 367.5 376 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 359.5 396 L 360 397.5 L 356.5 404 L 356 402.5 L 359.5 396 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 355.5 405 L 356 406.5 L 352.5 412 L 352 410.5 L 355.5 405 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 351.5 413 L 351 414.5 Q 342.2 433.7 326.5 446 L 326 444 L 327.5 444 L 337 434.5 L 351.5 413 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 219.5 446 L 222 446.5 L 219.5 447 L 219.5 446 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 210.5 451 L 213 451.5 L 210.5 452 L 210.5 451 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 314.5 451 L 317 451.5 L 314.5 452 L 314.5 451 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 133.5 452 L 134.5 454 L 133.5 452 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 288.5 453 L 287.5 455 L 286 454.5 L 288.5 453 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 240.5 454 L 243 455.5 L 241.5 455 L 240.5 454 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 165.5 460 L 168 460.5 L 165.5 461 L 165.5 460 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(36,36,39)",
    stroke: "rgb(36,36,39)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 269.5 460 L 272 460.5 L 269.5 461 L 269.5 460 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 236.5 59 L 235.5 61 L 236.5 59 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 242.5 63 L 279.5 63 L 281 64.5 L 280 66.5 L 281 70.5 L 281 72.5 L 281 112 L 239 112 L 239 66.5 L 240 64 L 242.5 63 Z M 241 65 L 241 111 L 278 111 L 278 65 L 241 65 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 155.5 124 L 156 149.5 L 155 149.5 L 155.5 124 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 371.5 124 L 372 149.5 L 371 149.5 L 371.5 124 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 142.5 150 L 146 150.5 L 142.5 151 L 142.5 150 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 381.5 150 L 384 150.5 L 381.5 151 L 381.5 150 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 259.5 222 L 262 222.5 L 259.5 223 L 259.5 222 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 264.5 222 L 268 222.5 L 264.5 223 L 264.5 222 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 256.5 239 L 266.5 240 L 270.5 239 L 270.5 240 L 268 240.5 L 271.5 241 L 273.5 240 L 273.5 242 L 276.5 241 L 283 243.5 L 277 246.5 Q 278 249 282.5 248 L 286 245.5 L 284 244.5 L 285.5 244 L 300 249.5 L 299.5 251 L 302.5 250 L 309 252.5 L 308.5 254 L 311.5 253 L 310.5 255 L 303.5 254 L 302 254.5 L 302.5 253 L 299.5 254 L 299.5 252 L 295 251 Q 296.1 248.3 293.5 249 L 287.5 252 L 283.5 250 L 279.5 252 L 269 245.5 L 272 245 L 273.5 248 L 274.5 245 L 277 243.5 Q 277.8 241.3 275.5 242 L 272.5 244 L 272.5 242 L 261.5 241 L 255 243.5 L 255.5 245 Q 252.9 245.7 254 243 L 251.5 243 Q 249.7 240.2 248 244.5 L 248.5 246 L 252.5 245 L 252.5 246 L 250 246.5 L 252 247 Q 253.5 250.8 250.5 250 L 245.5 247 L 239 248.5 L 243 250 Q 244.1 253.5 236.5 252 L 233.5 248 L 231 249.5 L 233 250.5 Q 229.3 252.2 232.5 254 Q 236.3 253.3 237 255.5 L 233.5 257 L 231 255.5 L 231.5 254 Q 227.8 255 229 252 L 225.5 252 L 223.5 253 L 221 252 Q 219.8 255 223.5 254 L 226 255.5 Q 225 258 220.5 257 L 215 253.5 L 222.5 251 L 224 251.5 Q 223.3 249.3 225.5 250 L 227.5 251 L 227.5 249 L 233.5 247 L 235.5 248 L 235.5 246 L 238.5 247 L 238.5 245 L 241.5 246 L 241.5 244 L 244.5 245 L 244.5 243 L 247.5 244 L 247.5 242 L 251.5 241 L 253.5 242 L 253.5 240 L 256.5 239 Z M 257 240 L 257 241 L 260 241 L 257 240 Z M 286 247 L 286 250 L 289 249 Q 290 246 286 247 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 254.5 250 Q 256.8 249.3 256 251.5 L 249.5 256 L 246 253.5 Q 247.8 251.3 252.5 252 L 254.5 250 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 274.5 252 L 278 253.5 L 274 254 Q 275 257 272 256 L 274.5 252 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 292.5 253 L 298 255.5 L 296 255.5 Q 296.9 258.9 291.5 257 L 287.5 257 L 279.5 257 L 278 255.5 Q 279.8 252.3 286.5 254 L 289.5 255 L 292.5 253 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 212.5 254 Q 215.5 253.2 214 257 L 207 259.5 L 207.5 261 L 205.5 260 L 205.5 262 L 202 263.5 L 204 264 Q 205.3 267.3 200.5 266 L 198.5 268 L 191 268 L 191 266 L 186 266 Q 187.3 269.3 182.5 268 L 176.5 270 L 175 267.5 L 193.5 261 L 195 261.5 Q 194.3 259.3 196.5 260 L 198 260.5 Q 197.3 258.3 199.5 259 L 201 259.5 Q 200.3 256.9 203 258 Q 201.9 260.7 204.5 260 L 204 258.5 Q 203.3 256.3 205.5 257 L 207.5 256 L 209 256.5 Q 208.3 254.3 210.5 255 L 212.5 256 L 212.5 254 Z M 199 261 Q 197 264 192 263 L 191 266 L 197 266 L 200 263 Q 201 265 202 263 Q 203 260 199 261 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 241.5 254 L 242.5 256 Q 239.7 256.7 241.5 254 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 313.5 254 L 329 259 Q 330.3 262 326.5 261 L 325 260.5 Q 326.1 263.8 323.5 263 L 319.5 264 L 319.5 263 Q 323.7 264.3 322 259.5 L 322.5 258 L 317.5 259 L 315 257.5 L 315 260 Q 320.2 258.3 319 262 L 313 259.5 L 312 255.5 L 313.5 254 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 264.5 256 L 265 257.5 L 264.5 259 L 268 261.5 L 268 408.5 L 266 410.5 L 268 411 L 266 414.5 L 268 415.5 L 262.5 416 L 263 414.5 L 264 412.5 L 262.5 412 L 261 416 L 259 415.5 Q 261.3 414.3 258.5 413 Q 254.8 414 256 411 L 259.5 412 Q 262.3 410.8 260 409.5 L 260.5 408 L 261 410 L 266 410 L 266 408.5 L 267 407.5 L 267 262.5 L 266 260 L 261 260 L 261 261.5 L 260 262.5 L 260 406.5 L 258.5 408 L 258 264 L 256 263.5 L 257.5 263 L 259 263.5 Q 258.5 258.5 262.5 258 Q 265 258.7 264.5 256 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 258 258 L 260 258.5 L 258 259.5 L 258 258 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 269.5 260 L 272 263.5 L 270 264 L 269.5 409 L 269.5 260 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 330 260 L 332 260.5 L 331.5 262 L 334.5 261 L 334.5 262 L 333 262.5 L 334 266 Q 331 265 332 268 L 328.5 268 L 324 269 L 325.5 266 L 328 264.5 L 327.5 263 L 330.5 264 L 330 262.5 L 330 260 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 312.5 261 L 313.5 263 Q 310.7 263.7 312.5 261 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 336 262 L 346 265.5 L 342.5 267 L 342.5 265 L 340.5 266 L 339 265.5 Q 338.3 267.8 340.5 267 L 340.5 268 L 335 266 L 336 262 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 347 266 L 352 267.5 L 348.5 269 L 347 266 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 172 268 L 175 269.5 L 171.5 271 L 169 270 L 165.5 276 L 160 277.5 L 164.5 278 L 166.5 277 L 165.5 279 L 163.5 280 L 160 279 L 158.5 283 L 154 279.5 L 156 279.5 L 153.5 276 L 152 275.5 L 164.5 271 L 166 271.5 L 166.5 270 Q 168 272.5 169.5 269 L 171.5 270 L 172 268 Z M 157 274 L 157 278 L 161 276 L 157 274 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 200.5 268 L 204.5 268 L 209 271.5 Q 207.5 274.5 206 271.5 Q 206.9 268.1 201.5 270 L 200.5 268 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 353 268 L 355 268.5 L 354.5 270 L 357.5 269 L 361 270.5 L 360.5 272 L 363.5 271 L 363.5 272 L 362 272.5 L 364.5 273 L 366.5 272 L 370 273.5 L 368 274 Q 366.9 276.7 369.5 276 L 372.5 274 L 378 276.5 L 376 277.5 Q 376.8 275.3 374.5 276 L 372 277 Q 370.9 279.7 373.5 279 L 373.5 280 L 370 279 Q 371.4 275.3 365.5 277 L 360 279.5 L 364 281.5 Q 362.8 285.3 366.5 284 Q 368.8 281.3 374.5 282 L 380 286.5 Q 380.8 288.8 378.5 288 Q 376.5 284 368.5 286 L 366 287.5 L 363.5 284 Q 356.3 284.3 352.5 288 Q 350.3 287.3 351 283.5 L 357.5 279 Q 359 281.5 360.5 278 L 364 276.5 L 361 275.5 Q 363.3 274.3 360.5 273 L 354.5 271 L 354.5 272 Q 356.8 271.3 356 273.5 L 352.5 275 Q 350.5 271.5 344.5 272 Q 343 274.5 337.5 273 L 336.5 271 L 344.5 269 L 344.5 271 L 353 270 L 353 268 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 186.5 269 L 189 269 Q 187.8 272 191.5 271 L 191.5 272 L 184 273 L 183 270.5 L 186.5 269 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 197.5 270 Q 200.1 269.3 199 272 L 196 271.5 L 197.5 270 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 319 270 L 323 270 L 323 271.5 L 320.5 273 L 319 270 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 331.5 270 Q 334.1 269.3 333 272 L 330 271.5 L 331.5 270 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 149.5 276 Q 152.5 275.2 151 279 Q 146.9 277.7 148 281 L 155 283.5 L 153.5 286 L 151 287.5 L 151.5 289 L 148 288 Q 149.3 284.7 144.5 286 L 143.5 284 Q 146.1 284.7 145 282 L 141.5 284 L 138.5 284 L 134 281.5 L 139 280 Q 137.8 283 141.5 282 L 140.5 279 L 143.5 280 L 143.5 278 L 147.5 277 L 149.5 278 L 149.5 276 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 174 276 Q 177.7 274.6 176 280.5 Q 174.6 283.3 170 282 L 170 288 L 164 288 L 164 286 L 166 286 L 166 284 L 168 284 L 168 282 L 170 282 L 170 280 L 172 280 L 174 276 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 379.5 277 L 381 277.5 L 379 278 L 380 282 L 388 283.5 L 386 284.5 L 386 286.5 Q 387.3 291.3 384 290 L 385 287.5 L 384 285.5 L 384.5 284 L 380 284 L 380 282 Q 374.8 283.7 376 280 Q 378.7 281.1 378 278.5 L 379.5 277 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 382.5 278 L 387 279.5 L 384.5 281 Q 382.8 277.9 381 279.5 L 382.5 278 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 388.5 280 L 399 283.5 L 397 284 L 396 286.5 L 396.5 288 L 395 286.5 L 395.5 283 L 393.5 284 L 393 282 L 390 282.5 Q 394.3 284.8 392.5 287 Q 395.1 286.2 394 289.5 L 393 289.5 Q 393.8 286.9 390.5 288 L 390 285.5 L 388.5 282 L 387 281.5 L 388.5 280 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 131.5 282 Q 133.8 281.3 133 283.5 L 133.5 285 L 131 285.5 L 131.5 287 L 128.5 286 L 124.5 287 L 123.5 285 L 125.5 286 L 126 284 L 129.5 283 L 131.5 284 L 131.5 282 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 84.5 283 L 82.5 286 L 84.5 283 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 120 286 L 125 289.5 L 126 294.5 L 125 297 L 123 297 L 123 299 Q 120.3 297.9 121 300.5 L 121.5 302 L 119.5 302 L 117.5 303 L 113.5 301 L 110.5 302 L 107 300 Q 108.3 303 104.5 302 Q 103.8 304.8 99.5 304 L 101 301.5 L 101 300 L 96 300 L 95.5 303 L 93 302 Q 92 299 95 300 L 95 296.5 L 94.5 295 L 98.5 294 L 100.5 295 L 100.5 293 L 103.5 292 L 106.5 293 L 106.5 291 L 108.5 292 L 108.5 290 L 118.5 287 L 120 287.5 L 120 286 Z M 120 289 L 115 293 L 112 292 L 110 293 Q 113 294 112 297 L 108 296 L 108 295 L 107 294 L 103 296 Q 98 295 99 298 L 103 300 Q 108 301 109 298 Q 111 297 110 300 L 119 297 L 121 295 Q 122 288 120 289 Z M 112 290 L 112 291 L 115 291 L 112 290 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 136.5 286 L 140.5 287 L 142 286.5 Q 142.8 288.8 140.5 288 L 136.5 289 Q 133.5 287.5 136.5 286 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 157.5 286 L 161 287.5 L 157.5 289 Q 154.5 287.5 157.5 286 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 445.5 287 L 447 289.5 L 446 289.5 L 445.5 287 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 150.5 291 L 152 291.5 L 150 292.5 L 152 295.5 L 150.5 299 L 150 296.5 Q 152.3 295.3 149.5 294 L 145 293.5 Q 146.2 290.8 147.5 293 L 150.5 291 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 392.5 292 L 394 296.5 L 392 296.5 L 393 300.5 L 389.5 311 L 388.5 308 L 388 311.5 L 389 313.5 L 386.5 320 L 385.5 317 L 385 320.5 L 386 322.5 L 384 321.5 L 385 315.5 L 384.5 314 Q 387.5 314.9 386 310.5 L 387 307 L 389.5 308 L 390 305.5 L 388 305.5 L 389 303.5 L 388 298 L 392 296 L 392.5 292 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 91.5 296 L 93 296.5 L 90 298.5 L 92 299 Q 93 302 90 301 L 90 304 L 88 304 L 89 301.5 Q 87 298 85 302.5 L 87 303 L 85 306.5 L 85.5 308 Q 82.9 307.2 84 310.5 L 86 310.5 L 84.5 314 L 83 307 L 81 306.5 L 83 306 Q 81.9 303.3 84.5 304 L 84 302.5 L 88.5 298 L 91.5 296 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 138.5 296 L 141 296.5 L 138.5 297 L 138.5 296 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 134.5 297 L 137 297.5 L 124.5 302 L 125.5 300 L 134.5 297 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 437.5 297 L 439.5 300 L 437.5 297 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 149.5 300 L 150.5 304 L 151.5 300 L 152 303.5 L 149 311.5 L 150 312.5 L 150 320 L 148 320.5 L 148 330.5 L 146.5 338 L 146 328.5 L 147 327.5 L 147 316 Q 150.3 317.3 149 312.5 L 148 309.5 L 149 308.5 L 149.5 300 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 441.5 301 L 442.5 303 L 441.5 301 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 107.5 304 L 112 305.5 L 104.5 308 L 104.5 306 L 99.5 306 L 96.5 309 L 87.5 312 L 87 309.5 L 89.5 307 L 95.5 306 L 97.5 307 Q 98.8 303.8 104.5 305 L 107.5 306 L 107.5 304 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 113.5 304 L 116 304.5 L 113.5 305 L 113.5 304 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 445.5 305 L 446 307 L 444 306.5 L 445.5 305 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 100.5 308 L 103 308.5 L 98 311.5 Q 102.8 317.2 103 327.5 L 102 327.5 L 101 319.5 L 97 310 L 100.5 308 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 94.5 313 L 97 314.5 L 98 316.5 Q 96.4 319.5 91 318 L 92.5 314 L 94.5 313 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 151.5 313 L 152 323.5 L 151 323.5 L 151.5 313 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 85.5 316 Q 87.8 315.3 87 317.5 L 90 318.5 L 92.5 328 L 93.5 324 L 94 328.5 L 92 331.5 L 96 337.5 L 95 339.5 Q 98.7 341.7 98 348.5 L 97 348.5 L 96 346.5 L 97 344 Q 94.3 345.1 95 342.5 L 93 337.5 Q 95.5 336 92 334.5 L 85.5 316 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 368 320 L 374 320 L 374 326 L 368 326 L 368 320 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 98.5 323 Q 100.8 323.8 100 327.5 L 98 326.5 L 98.5 323 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 96.5 324 L 97 327.5 L 96 327.5 L 96.5 324 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 149.5 324 L 150 327.5 L 149 327.5 L 149.5 324 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 383 325 Q 385.7 323.9 385 326.5 L 378.5 344 L 378 342.5 L 379 340 Q 376 341.3 377 337.5 L 379 331.5 Q 376.7 330.3 379.5 329 L 381.5 333 L 383 325 Z M 380 335 L 379 339 L 380 339 L 380 335 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 151.5 328 L 152 333.5 L 151 333.5 L 151.5 328 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 376.5 330 L 377 333.5 L 376 333.5 L 376.5 330 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 104.5 334 L 105 337.5 L 104 337.5 L 104.5 334 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 106.5 334 L 109 341.5 Q 106.4 342.9 107 347.5 L 108 351.5 L 107 351.5 L 106 343.5 L 106.5 342 Q 103.9 342.8 105 339.5 L 106.5 334 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 149.5 335 Q 152 336 151 340.5 L 150 340.5 L 149.5 335 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 145.5 339 L 146 343.5 L 145 343.5 L 145.5 339 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 148.5 340 L 149 343.5 L 148 343.5 L 148.5 340 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 376.5 342 L 378 347 Q 375.3 345.9 376 348.5 L 376 350.5 L 374.5 356 L 374 348.5 Q 377.1 347.1 376.5 342 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 104.5 343 L 105 344.5 L 104 347.5 L 105 351.5 L 102 352.5 L 104 357.5 L 103 360.5 Q 105.2 361.8 104 366.5 L 106.5 370 L 107 368 L 109 368.5 L 107 372.5 L 109 372.5 L 111 375.5 L 111 377.5 L 112 382.5 L 111.5 384 L 114 384 Q 112.7 389.3 116 388.5 L 116 391.5 Q 113.7 392.8 116.5 394 L 117.5 392 L 118 394.5 L 117 399.5 L 119 404.5 L 117 405.5 L 114 397.5 L 115 394.5 L 113 394.5 L 102 363.5 L 103 362.5 L 100 357.5 L 98 351.5 L 100 344 Q 103 342.8 102 346.5 L 100 349.5 L 101.5 352 L 102.5 349 L 103.5 352 L 104 348.5 L 103 344.5 L 104.5 343 Z M 111 380 L 110 383 L 111 383 L 111 380 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 109.5 343 L 111 347.5 L 109 348 L 109.5 343 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 110 353 Q 113.8 351.5 113 354.5 L 116 360.5 L 119 375.5 L 118 375.5 L 115 360.5 L 112.5 355 L 110 356 L 110 353 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 143.5 355 L 144 362.5 L 143 363.5 L 142.5 372 L 142 363.5 L 143.5 355 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 370.5 358 L 371 360 Q 373.7 358.9 373 361.5 L 360 395.5 L 354 408 L 352 408.5 L 352.5 410 L 349 408.5 L 353 405.5 L 355.5 397 L 357 397.5 L 356 392.5 L 362 387.5 L 360 386.5 L 361 384 L 358 382.5 Q 357 378.8 360 380 L 360 376.5 L 362.5 376 Q 365.1 376.7 364 374 L 367 374 L 367 370.5 L 368.5 366 L 370 366.5 L 368 362 Q 370.7 363.1 370 360.5 Q 367.8 359.3 370.5 358 Z M 364 376 Q 363 379 366 378 Q 367 375 364 376 Z M 355 402 L 354 405 L 355 405 L 355 402 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 112.5 359 L 113 361.5 L 112 361.5 L 112.5 359 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 112.5 366 L 113.5 368 L 114.5 366 L 116 376 Q 112 377.4 114 370.5 L 112.5 366 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 360 368 Q 362.7 366.9 362 369.5 L 360 370.5 L 360 368 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 110.5 369 L 111 371.5 L 110 371.5 L 110.5 369 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 141.5 374 L 143 377.5 L 142 377.5 L 141.5 374 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 120.5 376 L 121 378.5 L 120 378.5 L 120.5 376 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 121.5 380 L 123 383.5 Q 121.5 386.5 120 383.5 L 121.5 380 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 140.5 382 L 143 384.5 L 144 398.5 L 143 398.5 L 142.5 392 L 142 401.5 Q 144.8 403.2 143 409.5 L 142 409.5 L 140 387.5 L 141 387.5 L 141.5 392 L 142 384 Q 138.8 385 140.5 382 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 123.5 385 L 127 397.5 L 126 397.5 L 123.5 389 L 122 389.5 Q 121.3 385.8 123.5 385 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 139.5 397 L 141 405.5 L 141 415.5 L 139.5 420 Q 136.5 418 137 412.5 L 138 412.5 Q 136.7 417.3 140 416 L 139.5 397 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 126.5 399 L 129 401.5 L 131 407.5 L 126 408 Q 127 405 124 406 L 124 403.5 L 126.5 399 Z M 129 404 L 128 407 L 129 407 L 129 404 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 119.5 406 L 120.5 409 L 122 408.5 L 121 412.5 L 123.5 417 L 126 416 L 125.5 419 L 124 418.5 Q 121.9 424.4 126.5 423 L 126.5 424 Q 124.3 423.3 125 425.5 L 128 426.5 L 129.5 437 L 132 436 L 135 440.5 L 135 444.5 L 134 444.5 L 133.5 443 L 133 445.5 L 134.5 448 L 135.5 446 L 136 447.5 L 133 449 L 133 446 Q 130 447.3 131 443.5 L 126 431.5 L 127 430.5 L 124 425.5 L 118 407.5 L 119.5 406 Z M 131 437 L 130 440 L 131 440 L 131 437 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 138.5 408 L 139 410.5 L 138 410.5 L 138.5 408 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 128.5 409 L 129 412.5 L 128 412.5 L 128.5 409 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 130.5 409 L 131 412.5 L 130 412.5 L 130.5 409 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 123 410 L 126 411.5 L 125.5 414 L 123 413 L 123 410 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 346 411 Q 349.3 409.7 348 414.5 L 350 413.5 L 351.5 411 L 352 412.5 L 345 424 L 343 424.5 L 344 425.5 L 341 428.5 L 327.5 444 L 326 444 L 325.5 446 L 306.5 446 L 303.5 447 L 303.5 446 L 305 445.5 L 301.5 445 L 300 445.5 Q 299.5 442.5 306.5 444 L 311.5 443 L 311.5 444 L 308 444.5 L 312.5 445 Q 313.7 442.8 318.5 444 L 320 444.5 Q 319.1 441.5 323.5 443 Q 325 439.5 326.5 442 L 329 441.5 L 327 440.5 L 329 439.5 L 328 437.5 L 329.5 438 Q 334.3 438.8 335 435.5 L 336.5 431 L 338 431.5 L 337 428 L 339 428 L 339 425 Q 341.7 426.1 341 423.5 Q 342.2 420.3 346 421 L 347 418.5 L 345 417.5 L 348 416.5 L 346 411 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 132.5 413 L 133 418.5 L 132 418.5 L 131 414.5 L 132.5 413 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 143.5 416 L 144 418.5 L 143 418.5 L 143.5 416 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 134.5 421 L 137 422.5 L 136.5 424 L 134.5 421 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 336 424 L 338 424.5 L 336.5 427 L 336 424 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 134 432 L 136 432.5 L 134.5 437 L 133 434.5 L 134 432 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 200 432 L 206.5 432 L 207 434 L 200.5 434 L 200 432 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 320 432 L 326 432 L 326 434 L 320 435 L 320 432 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 329.5 432 L 330 433.5 L 328 434.5 L 329.5 432 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 209 436 L 223.5 436 L 224 438 L 209.5 438 L 209 436 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 304 436 L 318.5 436 L 319 438 L 304.5 438 L 304 436 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 142 438 L 144 438.5 L 144 448.5 L 143 450.5 L 144.5 452 L 159.5 452 L 162 450.5 L 162.5 452 L 175.5 452 L 176 453.5 L 178 452.5 Q 177.3 450.3 179.5 451 L 181.5 451 L 187 449.5 L 186.5 448 L 190 449.5 L 189.5 451 L 188 450.5 L 187.5 452 L 186 451.5 L 185.5 453 L 184 452.5 Q 184.8 454.8 182.5 454 L 177.5 457 L 176 456.5 L 175.5 458 Q 173.8 454.5 168 456 L 168.5 458 L 173 457 L 172.5 459 L 169.5 458 L 169.5 460 L 154.5 461 L 154.5 460 L 157.5 458 Q 159.2 460.8 164.5 460 L 168 458.5 L 165 457.5 L 168 455.5 L 167.5 454 L 148 454 L 148 456 L 144 456 L 144 457.5 L 143 457.5 L 144 455.5 L 142 455 L 141.5 457 L 140.5 455 L 138.5 456 L 137.5 454 L 140 455 Q 141.3 451.7 136.5 453 Q 134.8 455.8 133 451.5 L 133.5 450 L 134.5 452 L 135.5 450 L 141.5 454 L 144 452.5 L 141 450.5 L 142 448.5 Q 138.8 447.1 140 442 Q 143.7 443.2 142 438 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 199.5 440 L 201 440.5 L 200.5 442 L 216 445 Q 214.7 441.7 219.5 443 L 223.5 444 L 225.5 443 L 225.5 444 L 224 444.5 Q 225.3 448.7 231.5 448 L 233 447.5 L 234.5 450 L 235.5 448 L 236 450 L 250 454 Q 248.8 457 252.5 456 L 256 457 L 254.5 460 Q 252.3 460.8 253 458.5 L 251.5 459 L 247 458 L 246.5 456 L 244.5 456 L 242 454.5 L 244 453.5 L 240.5 453 L 238.5 453 L 237 452.5 L 237.5 451 L 235.5 452 Q 230.6 447.9 222.5 447 L 220.5 445 L 219.5 446 L 202.5 446 L 196.5 448 L 196.5 447 L 201 445.5 L 196 444.5 L 202 443.5 L 197.5 442 L 192.5 444 L 192 442 L 199.5 440 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 299.5 441 L 304 441.5 Q 298.6 441.6 296.5 445 L 296 443 L 299.5 441 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 227.5 444 L 231 445.5 Q 231.8 447.8 229.5 447 L 227.5 444 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 104.5 446 L 111 446.5 L 104.5 447 L 104.5 446 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 298.5 446 L 299 449 L 293.5 451 L 292 450.5 L 291.5 452 L 289.5 451 L 289.5 453 L 288 452.5 L 287.5 454 L 286 453.5 L 284.5 456 L 279.5 458 L 275.5 458 Q 272.9 457.3 274 460 L 269.5 460 L 268.5 461 L 258 461 Q 256.9 458.3 259.5 459 Q 261 456.5 266.5 458 L 271.5 459 L 271.5 457 L 273.5 457 L 278 456.5 L 277.5 455 L 282.5 452 L 287.5 452 Q 288.6 449.3 292 450 L 292.5 448 L 293.5 450 L 295.5 447 Q 297 449.5 298.5 446 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 416.5 446 L 419 446.5 L 416.5 447 L 416.5 446 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 421.5 446 L 424 446.5 L 421.5 447 L 421.5 446 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 193.5 447 Q 196.1 446.3 195 449 L 191.5 450 L 191 448 L 193.5 447 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 184.5 448 L 183.5 450 L 182 449.5 L 184.5 448 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 254 448 Q 257.1 447.3 256.5 450 L 272 450 Q 271 447 274 448 Q 275 451 272 450 L 272 452.5 L 270.5 454 L 257.5 454 L 256 450 Q 253 451 254 448 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 150.5 458 Q 153.1 457.3 152 460 L 149 459.5 L 150.5 458 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,59)",
    stroke: "rgb(44,48,59)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 52.5 465 L 53.5 467 L 52.5 465 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 239.5 56 L 242 56.5 L 239.5 57 L 239.5 56 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 283.5 56 Q 291.6 55.9 294 61.5 L 295 66.5 L 294 66.5 Q 293.9 60.1 289.5 58 L 283.5 57 L 283.5 56 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 237.5 57 L 233.5 62 L 237.5 57 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 232.5 63 L 233 65.5 L 232 65.5 L 232.5 63 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 161.5 111 L 232 111.5 L 161.5 112 L 161.5 111 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 295.5 111 L 366.5 111 L 368 112.5 L 366.5 112 L 295.5 112 L 295.5 111 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 370.5 113 L 371.5 115 L 370.5 113 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 154.5 114 L 152.5 117 L 154.5 114 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 373.5 115 L 374.5 117 L 373.5 115 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 151.5 118 L 150.5 120 L 151.5 118 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 162.5 118 L 354.5 118 L 356.5 119 L 359.5 118 Q 361 120.5 366.5 119 L 370 121.5 L 371 123.5 L 371 150 L 156.5 150 L 156 149.5 L 156 123.5 L 159.5 119 L 162.5 118 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 377.5 121 L 378 123.5 L 377 123.5 L 377.5 121 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 148.5 131 L 149 146.5 L 148 146.5 L 148.5 131 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 136.5 150 L 139 150.5 L 136.5 151 L 136.5 150 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 388.5 150 L 391 150.5 L 388.5 151 L 388.5 150 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 131.5 152 L 133 152.5 L 124.5 159 L 128.5 154 L 131.5 152 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 394.5 152 L 398 154.5 L 395.5 153 L 394.5 152 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 399.5 155 L 401.5 158 L 399.5 155 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 123.5 160 L 122.5 162 L 123.5 160 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 403.5 160 L 404.5 162 L 403.5 160 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 408.5 172 L 409 263.5 L 410 264.5 L 408 263.5 L 408.5 172 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 262.5 222 L 270.5 223 L 297.5 232 L 323.5 242 L 395.5 266 L 403.5 270 L 406.5 270 L 432.5 280 L 435.5 280 L 445 286.5 L 448 292.5 L 448 298.5 L 446 305 Q 443.3 306.1 444 303.5 L 440.5 299 L 431.5 294 L 428.5 294 L 414.5 288 L 381.5 278 L 274.5 240 L 263.5 238 L 240.5 244 L 203.5 258 L 188.5 262 L 174.5 268 L 171.5 268 L 151.5 276 L 148.5 276 L 122.5 286 L 113.5 288 L 105.5 292 L 96.5 294 Q 88.5 296.5 84 302.5 L 82.5 305 Q 80.3 305.8 81 303.5 Q 77.8 300.2 79 292.5 Q 80.5 286 85.5 283 L 102.5 276 L 177.5 251 L 200.5 242 L 203.5 242 L 229.5 232 L 262.5 222 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 98.5 270 L 100 270.5 L 96.5 272 L 96.5 271 L 98.5 270 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 426.5 270 L 430 271.5 L 428.5 271 Q 425.5 271.5 426.5 270 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 81.5 277 L 77.5 282 L 81.5 277 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 444.5 277 L 451 282.5 L 445.5 278 L 444.5 277 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 454.5 292 L 455 299.5 L 454 299.5 L 454.5 292 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 446.5 322 L 447 324.5 L 445 325.5 L 446.5 322 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 81.5 325 L 83 328.5 L 81 327.5 L 81.5 325 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 83.5 331 L 85 333.5 L 83 332.5 L 83.5 331 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 442.5 333 L 443 335.5 L 441.5 338 L 441 336.5 L 442.5 333 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 438.5 345 L 439 346.5 L 437.5 349 L 437 347.5 L 438.5 345 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 425.5 381 L 426 383.5 L 424.5 386 L 424 384.5 L 425.5 381 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 412.5 418 L 413 420.5 L 411 421.5 L 412.5 418 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 101.5 445 L 113 445.5 L 101.5 446 L 101.5 445 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 415.5 445 L 425 445.5 L 415.5 446 L 415.5 445 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 95.5 446 L 98 446.5 L 95.5 447 L 95.5 446 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 116.5 446 L 119 446.5 L 116.5 447 L 116.5 446 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 408.5 446 L 411 446.5 L 408.5 447 L 408.5 446 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 429.5 446 L 432 446.5 L 429.5 447 L 429.5 446 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 86.5 449 L 88 449.5 L 85.5 451 L 86.5 449 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 439.5 449 L 446 452.5 L 444.5 452 L 439.5 450 L 439.5 449 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 104.5 452 L 111 452.5 L 104.5 453 L 104.5 452 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 208.5 452 L 215 452.5 L 208.5 453 L 208.5 452 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 312.5 452 L 319 452.5 L 312.5 453 L 312.5 452 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 416.5 452 L 424 452.5 L 416.5 453 L 416.5 452 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 97.5 453 L 101 453.5 L 97.5 454 L 97.5 453 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 114.5 453 L 117 453.5 L 114.5 454 L 114.5 453 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 202.5 453 L 205 453.5 L 202.5 454 L 202.5 453 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 218.5 453 L 222 453.5 L 218.5 454 L 218.5 453 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 306.5 453 L 309 453.5 L 306.5 454 L 306.5 453 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 322.5 453 L 326 453.5 L 322.5 454 L 322.5 453 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 410.5 453 L 414 453.5 L 410.5 454 L 410.5 453 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 426.5 453 L 430 453.5 L 426.5 454 L 426.5 453 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 447.5 453 L 454 456.5 L 452.5 456 L 447.5 454 L 447.5 453 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 193.5 456 L 192.5 458 L 191 457.5 L 193.5 456 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 297.5 456 L 299 456.5 L 295.5 458 L 295.5 457 L 297.5 456 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 438.5 456 L 441 457.5 L 439.5 458 L 438.5 456 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 70.5 457 L 72 457.5 L 68.5 459 L 68.5 458 L 70.5 457 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 63.5 459 L 66 459.5 L 63.5 460 L 63.5 459 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 461.5 459 L 464 459.5 L 461.5 460 L 461.5 459 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 58.5 460 L 62 460.5 L 58.5 461 L 58.5 460 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 81.5 460 L 80.5 462 L 79 461.5 L 81.5 460 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 133.5 460 L 136 461.5 L 134.5 462 L 133.5 460 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 237.5 460 L 240 461.5 L 238.5 462 L 237.5 460 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 466.5 460 L 469 460.5 L 466.5 461 L 466.5 460 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 52.5 461 L 52 462.5 Q 51.3 466.8 54 467.5 L 51 465.5 Q 50.3 461.8 52.5 461 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 475.5 462 L 476 465.5 L 474 466.5 L 475.5 462 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 387.5 463 L 389 463.5 L 385.5 465 L 385.5 464 L 387.5 463 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 69.5 465 L 71 465.5 L 66.5 467 L 66.5 466 L 69.5 465 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 143.5 465 L 149 466.5 L 145.5 467 L 143.5 465 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 174.5 465 L 173.5 467 L 170 466.5 L 174.5 465 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 248.5 465 L 253 466.5 L 249.5 467 L 248.5 465 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 278.5 465 L 280 465.5 L 274.5 467 L 274.5 466 L 278.5 465 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 382.5 465 L 384 465.5 L 379.5 467 L 379.5 466 L 382.5 465 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 456.5 465 L 462 466.5 L 458.5 467 L 456.5 465 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 354.5 466 L 357 466.5 L 354.5 467 L 354.5 466 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 162.5 467 L 165 467.5 L 162.5 468 L 162.5 467 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(246,175,26)",
    stroke: "rgb(246,175,26)",
    strokeWidth: 1,
    opacity: 0.9372549019607843,
    d: "M 362.5 467 L 365 467.5 L 362.5 468 L 362.5 467 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 242.5 62 L 280 62.5 L 242.5 63 L 242.5 62 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 240.5 63 L 239.5 65 L 240.5 63 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 281.5 63 L 288 64 L 288 111.5 L 287.5 112 L 282 112 L 282 64.5 L 281.5 63 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 238.5 66 L 239 111.5 L 238 111.5 L 238.5 66 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 155.5 115 L 152.5 119 L 155.5 115 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 371.5 115 L 372.5 117 L 371.5 115 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 354.5 150 L 371 150.5 L 354.5 151 L 354.5 150 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 132.5 159 L 131.5 161 L 132.5 159 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 129.5 162 L 128.5 164 L 129.5 162 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 277.5 178 L 275.5 181 L 277.5 178 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 250.5 179 L 251.5 181 L 250.5 179 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 157.5 181 L 244 181.5 L 157.5 182 L 157.5 181 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 283.5 181 L 369 181.5 L 283.5 182 L 283.5 181 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 155.5 182 L 154.5 184 L 155.5 182 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 371.5 182 L 372.5 184 L 371.5 182 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 278.5 185 L 279 217.5 L 278 217.5 L 278.5 185 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 248.5 186 L 249 219.5 L 248 219.5 L 248.5 186 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 147.5 191 L 148 247.5 L 147 247.5 L 147.5 191 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 278.5 219 L 281 220.5 L 279.5 221 L 278.5 219 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 262.5 261 L 266 262.5 L 266 407.5 L 264.5 409 L 261 407.5 L 261 262.5 L 262.5 261 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 398.5 284 L 433.5 296 L 443 303.5 L 445 307.5 L 399 436.5 L 399 439.5 L 394 452.5 L 391.5 455 L 383.5 459 L 375.5 461 L 359.5 461 L 352 459 L 351.5 457 L 349.5 457 L 333.5 449 Q 328.3 446.3 320 446.5 L 326.5 446 L 339 433.5 L 346 424.5 L 362 393.5 L 368 377.5 L 368 374.5 L 371 370.5 L 376 352.5 L 381 341.5 L 384 328.5 L 395 297.5 L 397 290.5 L 397 285.5 L 398.5 284 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 448.5 294 L 449 297.5 L 448 297.5 L 448.5 294 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 204.5 446 L 208 446.5 L 204.5 447 L 204.5 446 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 216.5 446 L 219 446.5 L 216.5 447 L 216.5 446 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 308.5 446 L 312 446.5 L 308.5 447 L 308.5 446 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 103.5 451 L 106 451.5 L 103.5 452 L 103.5 451 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 108.5 451 L 111 451.5 L 108.5 452 L 108.5 451 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 207.5 451 L 210 451.5 L 207.5 452 L 207.5 451 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 317.5 451 L 320 451.5 L 317.5 452 L 317.5 451 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 416.5 451 L 419 451.5 L 416.5 452 L 416.5 451 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 421.5 451 L 424 451.5 L 421.5 452 L 421.5 451 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 176.5 457 L 178 457.5 L 174.5 459 L 174.5 458 L 176.5 457 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 149.5 460 L 152 460.5 L 149.5 461 L 149.5 460 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 253.5 460 L 256 460.5 L 253.5 461 L 253.5 460 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 155.5 461 L 163 461.5 L 155.5 462 L 155.5 461 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,25,30)",
    stroke: "rgb(24,25,30)",
    strokeWidth: 1,
    opacity: 0.9921568627450981,
    d: "M 260.5 461 L 267 461.5 L 260.5 462 L 260.5 461 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,1,2)",
    stroke: "rgb(2,1,2)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 242.5 57 L 284.5 57 L 292 61.5 L 294 66.5 L 294 113 L 366.5 113 L 374 117 L 377 124.5 L 377 151 L 388.5 151 Q 396.3 153.3 401 158.5 L 407 170.5 L 407 265 L 440.5 276 L 449 282.5 Q 453.3 287.7 454 296.5 L 407 432.5 L 401 446.5 L 401 450.5 L 402.5 450 Q 411.9 444.9 428.5 447 L 438.5 450 L 461.5 461 L 474 462 Q 475 465.8 472.5 467 L 455.5 464 L 438.5 455 L 429.5 452 L 416.5 451 L 401.5 455 L 381.5 465 L 365.5 467 L 348.5 463 L 334.5 455 L 325.5 452 L 312.5 451 L 302.5 453 L 277.5 465 L 260.5 467 L 246.5 464 L 224.5 453 L 214.5 451 L 207.5 451 L 195.5 454 L 173.5 465 L 156.5 467 L 142.5 464 Q 131.3 456.2 116.5 452 L 103.5 451 L 91.5 454 L 69.5 465 L 54.5 467 L 53 463.5 L 54.5 462 L 61.5 462 L 69.5 460 L 94.5 448 Q 102.4 445.4 114.5 447 L 126 450 L 109 398.5 L 79 316.5 L 73 295.5 L 76 285.5 L 81.5 279 L 86.5 276 L 120 265 L 120 170.5 Q 122.1 161.1 128.5 156 Q 135.3 149 150 151 L 150 123.5 L 157.5 114 L 159.5 113 L 233 113 L 233 66.5 L 237.5 59 L 242.5 57 Z M 243 62 L 241 63 L 238 67 L 238 112 L 274 112 L 278 112 L 288 112 L 288 112 L 288 64 L 280 62 L 243 62 Z M 161 118 L 159 119 L 155 124 L 155 151 L 371 151 L 372 150 L 372 124 L 370 120 L 367 118 L 161 118 Z M 139 156 L 133 159 Q 127 163 125 170 L 126 263 L 148 255 L 148 184 L 150 181 L 158 176 L 245 176 L 248 177 L 253 183 L 254 187 L 254 218 L 259 217 Q 268 216 273 218 L 273 186 L 274 183 Q 276 177 283 176 L 370 176 L 376 179 L 379 185 L 379 255 L 399 262 L 402 262 L 402 171 L 397 161 L 388 156 L 139 156 Z M 158 181 L 156 182 L 153 186 L 153 252 L 161 251 L 181 243 L 249 220 L 249 187 L 248 185 L 244 181 L 158 181 Z M 284 181 L 282 182 L 278 186 L 278 220 L 280 221 L 289 223 L 372 252 Q 373 254 374 252 L 374 186 L 373 184 L 369 181 L 284 181 Z M 258 222 L 86 282 Q 79 286 78 295 L 80 305 L 91 333 L 133 454 L 144 459 L 156 462 L 170 461 L 195 449 L 209 446 L 216 446 L 226 448 L 251 460 L 261 462 L 274 461 L 302 448 L 313 446 L 328 447 Q 342 451 353 459 L 360 461 L 376 461 L 384 459 L 392 455 L 394 453 L 399 440 L 406 417 L 420 380 L 420 377 L 449 298 Q 449 291 446 287 L 438 280 L 352 250 L 349 250 L 338 245 L 323 241 L 273 223 L 258 222 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241 65 L 278 65 L 278 111 L 241 111 L 241 65 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 156 L 386 156.5 L 381.5 157 L 381.5 156 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 162 L 397.5 164 L 396.5 162 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 172 L 402 260.5 L 400 261.5 L 401 260.5 L 401.5 172 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 178 L 150.5 180 L 151.5 178 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 182 L 372.5 185 L 370.5 182 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 183 L 154.5 185 L 155.5 183 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 186 L 154 251.5 L 153 251.5 L 153.5 186 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 373.5 187 L 374 251.5 L 373 251.5 L 373.5 187 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 260.5 216 L 266 216.5 L 260.5 217 L 260.5 216 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 261.5 241 L 267.5 241 L 277 243.5 L 274 245.5 L 275 246.5 L 273.5 249 L 281.5 252 Q 282.6 249.3 286 250 Q 284.5 245.5 289 247 L 287.5 250 L 286 250.5 Q 287.3 253.3 288.5 251 L 295 249 Q 293.8 252 297.5 251 L 300 252.5 L 299.5 254 L 302.5 253 Q 305.2 255.8 311.5 255 L 313 256.5 Q 312.3 260.3 314.5 261 L 319 262 Q 320.2 258.3 315 260 L 315 257.5 L 317.5 259 Q 324.3 257 322 263 L 319 263.5 L 322.5 264 L 325 263 L 325 261 L 330 261 L 331 263.5 L 329.5 264 L 327.5 263 L 326.5 266 L 324 267.5 Q 323.1 270.5 327.5 269 L 332 268 Q 331 265 334 266 L 334 263 L 335.5 263 L 335 264.5 Q 334.3 266.8 336.5 266 L 339 267 L 339.5 265 L 342.5 267 L 346.5 267 Q 347.9 270.1 353 269.5 L 344 271.5 L 354.5 275 L 356 272 L 354 271.5 L 356.5 271 L 362 274.5 L 361.5 276 L 364 276.5 L 360 278.5 L 362.5 279 Q 364.8 276 370 277 Q 369 280 372 279 Q 370.7 275.7 375.5 277 L 378 278 L 376 282 L 380 282 L 380 280.5 L 379.5 279 L 390 283.5 L 391 286.5 L 390.5 288 Q 393.8 286.9 393 289.5 L 394 289.5 Q 395.1 286.2 392.5 287 L 391.5 283 L 396 285.5 L 396 287.5 L 392.5 298 L 392 296 L 388 298 L 388 302.5 L 388 304.5 L 388.5 306 L 390 305.5 L 388.5 312 L 388 308.5 L 388.5 307 Q 385.9 306.2 387 309.5 L 386 313.5 L 387 315.5 L 386 315.5 Q 386.8 313.3 384.5 314 L 385 315.5 L 386 320.5 L 385 320.5 L 384.5 317 L 384 321.5 L 385 325 Q 382 323.8 383 327.5 L 381.5 333 L 379.5 329 Q 376.7 330.3 379 331.5 L 377 340 Q 379.7 338.9 379 341.5 L 377.5 345 L 376.5 342 L 376 346.5 L 377 348.5 L 376 348.5 L 375.5 347 L 374 348.5 Q 374.8 356.2 373 360 Q 370.3 361.1 371 358.5 L 369 359.5 L 371 363.5 L 370 363.5 Q 370.7 360.9 368 362 L 370 366.5 L 368 366.5 L 367 374 Q 362.9 372.7 364 376 Q 367 375 366 378 L 364 378 Q 365.1 375.3 362.5 376 L 360 376.5 L 361 381.5 L 360 381.5 Q 360.7 378.9 358 380 L 359.5 384 Q 361.8 383.3 361 385.5 L 360.5 387 L 362 387.5 L 356 392.5 L 356.5 395 L 358 394.5 L 356.5 398 L 355 397.5 L 356 400.5 L 354 400.5 L 355 404.5 L 354 404.5 L 353.5 402 Q 353.7 406.7 350.5 408 L 349 408.5 L 352 410.5 L 347.5 417 Q 346.3 414.8 345 417.5 L 347 418.5 L 346 421 Q 342.2 420.3 341 423.5 Q 341.7 426.1 339 425 L 339 427.5 L 340 429.5 L 339 429.5 Q 339.7 426.9 337 428 L 338 431.5 L 336 431.5 Q 335.8 436.3 332.5 438 L 328.5 437 L 328 438.5 Q 331.8 440.3 328.5 442 L 325.5 441 L 324.5 444 L 320 443 L 319.5 445 Q 318.3 442.8 313.5 444 L 308.5 445 L 308.5 444 L 312 443.5 L 307.5 443 L 306.5 444 L 300 444 L 300.5 446 L 304.5 445 L 304.5 446 L 299 448 L 298.5 446 L 294 448.5 L 292.5 451 L 289.5 450 L 289.5 451 L 291 451.5 L 288.5 453 Q 287.3 450.8 282.5 452 L 277 455.5 L 278.5 458 L 273.5 457 Q 272.5 460 267.5 459 Q 266 456.5 260.5 458 L 255.5 460 L 256 458.5 Q 256.8 455.9 253.5 457 L 250 456 Q 251.3 453 247.5 454 Q 244.5 451 238.5 451 L 236.5 452 L 236.5 451 L 238 450.5 L 236 450 L 235.5 448 L 234.5 450 L 232.5 447 L 228.5 448 L 223.5 444 L 216 443 Q 217.1 445.7 214.5 445 L 200.5 442 L 200.5 443 L 202 443.5 L 196 444.5 L 201 445.5 L 195.5 448 L 193.5 447 L 191 448 L 190.5 450 L 186.5 448 L 186.5 450 L 180.5 452 L 178 451 L 176.5 454 L 176 452 L 162.5 452 L 162 450.5 L 159.5 452 L 144.5 452 L 141.5 454 L 140 453.5 L 141 455.5 L 139.5 455 L 134 451.5 L 132 446.5 L 133.5 443 L 134.5 445 L 135 440.5 L 132 436 L 130 436.5 L 131 439.5 L 130 439.5 L 127.5 426 L 125 427.5 L 125 425.5 Q 124.3 423.3 126.5 424 L 126.5 423 Q 121.9 424.4 124 418.5 L 126 418.5 Q 127.1 415.2 124.5 416 L 123 416.5 L 121 412.5 L 122 408.5 L 120 408.5 L 119.5 406 L 118 406.5 L 119 403.5 Q 116.3 401.2 117 395.5 L 118 392.5 L 117 392.5 L 116.5 394 Q 113.7 392.8 116 391.5 L 116 388.5 Q 112.7 389.3 114 384 L 111.5 384 L 110 380.5 L 111 377.5 L 111 375.5 L 109 372.5 L 107 372.5 L 104 366.5 L 103 358.5 L 104 356.5 L 100 349.5 L 102 344 Q 99 342.8 100 346.5 L 98.5 351 L 97.5 344 L 96.5 346 L 96 344.5 L 97 341.5 L 95 338.5 L 95 336.5 L 92 330.5 Q 95 329.5 94 324.5 L 93 324.5 L 92.5 328 Q 92.4 320.6 88.5 317 L 87 317.5 Q 87.7 314.9 85 316 L 85 313.5 Q 87.5 312 84 310.5 Q 82.9 307.2 85.5 308 Q 83.9 306.3 87 304.5 L 86 302.5 L 88.5 301 L 88 302.5 Q 87.3 305.1 90 304 Q 88.7 299.9 92 301 L 92 297 L 95 297 L 95 300 Q 92 299 93 302 L 95.5 303 L 96 300 L 101 300 L 101 301.5 L 99.5 304 L 107 302 Q 108.3 298.3 102.5 300 L 99 298 Q 97.7 294.7 102.5 296 L 106.5 294 L 108 294.5 L 107.5 296 L 112 297 Q 112.8 293.6 110 292.5 L 111.5 292 L 114.5 293 L 121 289 Q 122.5 295.3 118.5 297 L 110 300 Q 111.1 297.3 108.5 298 L 107.5 300 L 112.5 302 L 114.5 301 L 117.5 303 L 121 300.5 L 125 295.5 L 126 291.5 L 123 287.5 L 134 284.5 L 133.5 283 L 141.5 284 L 145 282 Q 146.1 284.7 143.5 284 L 144.5 286 L 148.5 285 L 148 286.5 Q 147.3 288.8 149.5 288 L 151.5 289 L 152.5 286 L 155 284.5 L 153.5 282 L 148 281 L 148 279 Q 152.1 280.3 151 277 L 154.5 277 L 156 279.5 Q 153.2 281.2 157.5 283 L 160 281.5 L 158.5 278 Q 155.5 278.7 157 275 L 161 275.5 L 160.5 277 Q 165.6 277.6 167 274.5 L 169.5 271 Q 174.5 272 175.5 269 L 177.5 269 L 186 268 L 185 265.5 L 186.5 266 Q 191 267 192 264.5 Q 191.1 261.1 196.5 263 Q 197.8 260 202 261 Q 200.9 263.7 203.5 263 L 206 261.5 L 203 259.5 L 204.5 259 L 206.5 260 L 214 257 Q 212.7 253.3 218.5 255 Q 219.5 258 224.5 257 L 225.5 255 L 221 253.5 L 229 252 Q 227.8 255 231.5 254 L 232.5 250 L 231 249.5 L 235 249 L 236.5 252 Q 244.1 253.5 243 250 L 239 248.5 L 245.5 247 L 252 250 Q 253.5 246.3 250.5 247 L 250.5 246 L 253 245.5 L 249.5 245 L 247 246.5 L 249.5 243 L 254 243 Q 252.9 245.7 255.5 245 L 256.5 242 L 261.5 241 Z M 270 245 L 272 247 Q 273 244 270 245 Z M 255 250 L 253 252 Q 248 251 246 254 L 250 256 L 256 252 Q 257 249 255 250 Z M 275 252 L 272 256 Q 275 257 274 254 L 278 254 L 275 252 Z M 293 253 L 290 255 L 287 254 Q 280 252 278 256 L 280 257 L 288 257 L 291 256 L 296 257 L 297 255 L 293 253 Z M 233 254 L 231 256 L 234 257 L 237 256 Q 236 253 233 254 Z M 242 254 Q 240 257 243 256 L 242 254 Z M 258 258 L 258 260 L 260 259 L 258 258 Z M 263 258 L 258 265 L 258 408 L 260 407 L 260 410 Q 262 411 260 412 L 256 411 Q 255 414 259 413 Q 261 414 259 416 L 261 416 L 263 412 L 264 413 L 263 415 L 263 416 L 268 416 L 266 415 L 268 411 L 266 411 L 268 409 L 268 262 L 263 258 Z M 270 260 L 270 409 L 270 264 L 272 264 L 270 260 Z M 313 261 Q 311 264 314 263 L 313 261 Z M 200 263 L 197 266 Q 190 264 191 268 L 199 268 Q 200 265 204 266 Q 205 263 203 264 L 200 263 Z M 201 268 L 202 270 L 206 270 Q 205 267 201 268 Z M 187 269 L 183 271 L 184 273 L 192 272 L 192 271 Q 188 272 189 269 L 187 269 Z M 198 270 L 196 272 L 199 272 Q 200 269 198 270 Z M 206 270 L 206 272 Q 208 275 209 272 L 206 270 Z M 319 270 L 321 273 L 323 272 L 323 270 L 319 270 Z M 332 270 L 330 272 L 333 272 Q 334 269 332 270 Z M 339 270 L 336 272 Q 338 275 344 273 L 344 271 L 339 270 Z M 174 276 L 172 280 L 170 280 L 170 282 Q 175 283 176 281 Q 178 275 174 276 Z M 166 277 L 160 279 L 164 280 L 167 278 L 166 277 Z M 358 279 L 351 284 Q 350 287 353 288 L 361 284 Q 365 286 364 282 L 361 280 L 358 279 Z M 168 282 L 166 286 L 164 286 L 164 288 L 170 288 L 170 282 L 168 282 Z M 371 282 L 364 285 L 366 288 L 369 286 Q 376 284 379 288 Q 381 289 380 287 L 375 282 L 371 282 Z M 380 282 Q 379 286 385 284 L 384 286 L 385 288 L 384 290 Q 387 291 386 287 L 386 285 L 388 284 L 380 282 Z M 137 286 L 137 289 L 141 288 Q 143 289 142 287 L 141 287 L 137 286 Z M 158 286 Q 155 288 158 289 L 161 288 L 158 286 Z M 147 292 L 145 294 Q 150 293 152 296 L 152 295 Q 150 290 149 293 L 147 292 Z M 393 292 L 392 296 L 393 296 L 393 292 Z M 148 295 L 135 300 L 132 300 L 134 299 L 134 298 Q 129 297 128 300 L 131 301 L 105 310 L 102 310 L 100 312 L 105 326 L 104 328 L 106 328 L 116 359 L 115 361 L 117 372 L 118 372 Q 119 366 116 364 L 117 361 L 126 390 L 126 391 L 125 390 L 124 390 L 126 396 L 127 392 L 136 418 L 137 412 L 137 404 L 138 403 L 138 393 L 139 392 L 139 385 L 142 384 L 140 382 L 142 364 L 142 372 L 143 372 L 143 364 L 142 363 L 144 337 L 146 328 L 146 319 L 147 319 L 147 328 L 146 329 L 147 338 L 148 331 L 148 321 Q 151 321 150 313 L 149 313 Q 150 317 147 316 L 148 300 L 149 299 Q 150 294 148 295 Z M 139 296 L 139 297 L 141 297 L 139 296 Z M 151 296 L 150 299 L 151 299 L 151 296 Z M 135 297 L 135 298 L 137 298 L 135 297 Z M 126 300 L 126 301 L 128 301 L 126 300 Z M 150 300 L 149 309 L 151 308 L 150 300 Z M 152 300 L 151 304 L 152 304 L 152 300 Z M 114 304 L 114 305 L 116 305 L 114 304 Z M 100 305 L 100 306 L 105 306 L 100 305 Z M 109 305 L 106 306 L 105 308 L 112 306 L 109 305 Z M 92 306 L 90 307 Q 85 309 89 311 L 92 311 L 98 308 Q 96 305 92 306 Z M 101 308 L 101 309 L 103 309 L 101 308 Z M 149 309 L 148 312 L 149 312 L 149 309 Z M 97 310 L 97 312 L 99 311 L 97 310 Z M 95 313 L 93 314 L 91 318 Q 96 320 98 317 L 97 315 L 95 313 Z M 152 313 L 151 324 L 152 324 L 152 313 Z M 100 314 L 100 319 L 101 319 L 100 314 Z M 102 319 L 101 323 L 102 323 L 102 319 Z M 368 320 L 368 326 L 374 326 L 374 320 L 368 320 Z M 99 323 L 98 327 L 100 328 Q 101 324 99 323 Z M 103 323 L 102 328 L 103 328 L 103 323 Z M 97 324 L 96 328 L 97 328 L 97 324 Z M 150 324 L 149 328 L 150 328 L 150 324 Z M 152 328 L 151 334 L 152 334 L 152 328 Z M 377 330 L 376 334 L 377 334 L 377 330 Z M 105 334 L 104 338 L 105 338 L 105 334 Z M 107 334 Q 105 338 107 340 L 107 341 L 106 340 L 105 340 Q 104 343 107 342 L 106 344 L 107 352 L 108 352 L 107 348 Q 106 343 109 342 L 107 334 Z M 151 336 L 150 341 L 151 341 L 151 336 Z M 146 339 L 145 344 L 146 344 L 146 339 Z M 149 340 L 148 344 L 149 344 L 149 340 Z M 105 343 L 103 345 L 104 348 L 105 345 L 105 343 Z M 110 343 L 109 348 L 111 348 L 110 343 Z M 105 348 L 104 352 L 105 352 L 105 348 Z M 103 349 L 102 352 L 103 352 L 103 349 Z M 110 353 L 110 356 L 113 355 Q 114 352 110 353 Z M 114 355 L 113 358 L 114 358 L 114 355 Z M 144 355 L 143 363 L 144 363 L 144 355 Z M 113 359 L 112 362 L 113 362 L 113 359 Z M 115 366 L 113 369 L 114 371 Q 112 377 116 376 L 115 366 Z M 107 368 L 107 370 L 109 369 L 107 368 Z M 360 368 L 360 371 L 362 370 Q 363 367 360 368 Z M 111 369 L 110 372 L 111 372 L 111 369 Z M 119 372 L 118 376 L 119 376 L 119 372 Z M 121 376 L 120 379 L 121 379 L 121 376 Z M 112 380 L 111 383 L 112 383 L 112 380 Z M 143 384 L 143 399 L 144 399 L 143 384 Z M 124 385 Q 121 386 122 390 L 124 389 L 124 385 Z M 141 387 L 140 395 L 141 396 L 142 410 L 143 410 L 142 393 L 141 387 Z M 140 397 L 139 405 L 140 405 L 140 397 Z M 127 399 L 124 404 L 124 406 Q 127 405 126 408 L 131 408 L 130 404 L 129 407 L 128 407 L 129 404 Q 130 399 127 399 Z M 141 405 L 140 416 L 141 416 L 141 405 Z M 139 408 L 138 411 L 139 411 L 139 408 Z M 129 409 L 128 413 L 129 413 L 129 409 Z M 131 409 L 130 413 L 131 413 L 131 409 Z M 123 410 L 123 413 L 126 414 L 126 412 L 123 410 Z M 346 411 L 347 415 L 348 415 Q 349 410 346 411 Z M 138 412 L 137 416 L 138 416 L 138 412 Z M 133 413 L 131 415 L 132 419 L 133 419 L 133 413 Z M 138 416 L 138 419 L 140 420 Q 141 415 138 416 Z M 144 416 L 143 419 L 144 419 L 144 416 Z M 135 421 L 137 424 L 137 423 L 135 421 Z M 336 424 L 337 427 L 338 425 L 336 424 Z M 134 432 L 133 435 L 135 437 L 136 433 L 134 432 Z M 200 432 L 201 434 L 207 434 L 207 432 L 200 432 Z M 320 432 L 320 435 L 326 434 L 326 432 L 320 432 Z M 330 432 L 328 435 L 330 434 L 330 432 Z M 209 436 L 210 438 L 224 438 L 224 436 L 209 436 Z M 304 436 L 305 438 L 319 438 L 319 436 L 304 436 Z M 142 438 Q 144 443 140 442 Q 139 447 142 449 L 141 451 L 144 452 L 143 451 L 144 449 L 144 439 L 142 438 Z M 200 440 L 192 442 L 193 444 L 201 441 L 200 440 Z M 300 441 L 299 443 L 304 442 L 300 441 Z M 296 443 L 296 445 L 298 444 L 296 443 Z M 228 444 L 230 447 Q 232 448 231 446 L 228 444 Z M 134 446 L 133 449 L 135 449 L 134 446 Z M 254 448 Q 253 451 256 450 Q 257 447 254 448 Z M 272 448 Q 271 451 274 450 Q 275 447 272 448 Z M 136 450 L 137 453 L 140 453 L 136 450 Z M 256 450 L 258 454 L 271 454 L 272 453 L 272 450 L 256 450 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 245 Q 284.3 244.3 285 246.5 Q 283.3 248.8 278.5 248 L 277.5 246 L 280.5 245 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 281 L 142 281.5 L 139.5 282 L 139.5 281 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 335 L 93.5 337 L 92.5 335 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 335 L 380 338.5 L 379 338.5 L 379.5 335 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 394 L 115 396.5 L 114 396.5 L 114.5 394 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 452 L 244 453.5 L 240.5 454 L 239.5 452 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148 454 L 167.5 454 Q 166.5 457.5 173.5 456 L 174.5 458 L 169.5 457 L 169.5 458 L 172 458.5 L 169.5 459 L 167.5 459 L 160.5 460 L 156 458 Q 157.2 461.7 152 460 Q 153.1 457.3 150.5 458 L 147.5 459 L 144 458 L 143.5 456 L 142 456.5 Q 141.3 454.3 143.5 455 L 148 456 L 148 454 Z M 168 456 L 165 458 L 168 458 L 168 456 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(44,48,60)",
    stroke: "rgb(44,48,60)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 455 L 246.5 457 L 247.5 455 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarco);
export default __webpack_public_path__ + "static/media/BARCO.932191fa550e75385c47dd5592dc88ac.svg";
export { ForwardRef as ReactComponent };